import React from "react";
import { API_URL } from "src/scenes/App";
import axios from "axios";
import { useState } from "react";
import { Password, NewPassword, ConfirmNewPassword, ErrorList, ErrorStrings } from "./ChangePasswordFields";
import {
    Button,
    StandardModal,
    StandardModalActionGroup,
    StandardModalSection,
    Toast
} from "src/components";
const ChangePasswordForm = (props) => {
    const { showDialog, handleClose, token, isAccountOwner } = props;
    const [inputErrors, setInputErrors] = useState([]);
    const [formLoading, setFormLoading] = useState(false);
    const [formData, setFormData] = useState({
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
    });

    const handleInputChange = (event, key) => {
        const updatedFormData = { ...formData, [key]: filterInputValue(event.target.value) };
        setFormData(updatedFormData);
    };

    const handleFormSubmit = () => {
        if (formLoading) {
            return;
        }

        setInputErrors([]);
        const errors = getErrors();

        if (errors.length > 0) {
            setInputErrors(errors);
            setFormLoading(false);
            return;
        }

        savePassword(formData, setFormLoading, setInputErrors);
    };

    const savePassword = async (formData, setSavePasswordLoading, setInputErrors) => {
        setSavePasswordLoading(true);
        
        const route = isAccountOwner ? "changeAccountPassword" : "changePassword";
        axios.post(`${API_URL}/company/${route}`, formData, {
            headers: {
                Authorization: "Bearer " + token
            }
        }).then(() => {
            setSavePasswordLoading(false);
            handleClose(false);
            return Toast.info("Your password was updated.");
        }).catch(error => {
            if (!error.hasFormErrors()) {
                Toast.error(error.getApiErrorDetails().message);
                return;
            }

            let errors = [];
            error.getFormErrors().forEach(({ field, message }) => {
                const responseMessage = "* " + message;
                const fieldKey = field;
                switch (fieldKey) {
                case "passwordInvalid":
                    ErrorStrings[ErrorList.PASSWORD_INVALID] = responseMessage;
                    errors.push(ErrorList.PASSWORD_INVALID);
                    return;

                case "newPasswordInvalid":
                    ErrorStrings[ErrorList.NEW_PASSWORD_INVALID] = responseMessage;
                    errors.push(ErrorList.NEW_PASSWORD_INVALID);
                    return;
                        
                default:
                    //NO ERROR TO CATCH
                    return;
                }
            });

            setInputErrors(errors);
            setSavePasswordLoading(false);
        });
    };

    // prevents console warns when one of the input values are null
    const filterInputValue = (value) => [null].includes(value) ? "" : value;

    const getErrors = () => {
        let errors = [];
        
        if (formData.oldPassword === "" || formData.oldPassword === null) {
            errors.push(ErrorList.EMPTY_PASSWORD);
        }

        if (formData.newPassword === "" || formData.newPassword === null) {
            errors.push(ErrorList.EMPTY_NEW_PASSWORD);
        } else {
            //confirm password
            if (formData.confirmNewPassword === "" || formData.confirmNewPassword === null) {
                errors.push(ErrorList.EMPTY_CONFIRM_NEW_PASSWORD);
            } else if (formData.newPassword !== formData.confirmNewPassword) {
                errors.push(ErrorList.CONFIRM_NEW_PASSWORD_MISMATCHED);
            }
        }

        return errors;
    };
    
    return (
        <React.Fragment>
            <StandardModal
                open={showDialog}
                onClose={() => handleClose(false)}
                title="Change Password"
                widthMode="medium"
                footer={(
                    <StandardModalActionGroup $pushRight>
                        <Button
                            onClick={() => handleClose(false)}
                            size="0.875rem"
                            border="1px solid #000"
                            color="#000"
                            width="8.75rem"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={formLoading}
                            onClick={handleFormSubmit}
                            size="0.875rem"
                            backgroundColor="#171A22"
                            border="1px solid #171A22"
                            color="#fff"
                            width="8.75rem"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            {formLoading ? "Saving..." : "Save"}
                        </Button>
                    </StandardModalActionGroup>
                )}
            >
                <StandardModalSection>
                    <Password placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                    <NewPassword placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                    <ConfirmNewPassword placeholderDisabled={true} isEditable={!formLoading} formData={formData} onChangeFormData={handleInputChange} inputErrors={inputErrors}/>
                
                </StandardModalSection>
            </StandardModal>
        </React.Fragment>
    );
}; 

export default ChangePasswordForm;
